import { action, API, controller } from "api";
import { useAppContext } from "context";

import { useNavigate } from "react-router-dom";
import { clearSessionScopedCache } from "./Method";

const useLogout = () => {
  const { setAuthUser, setBizContext } = useAppContext();
  const navigate = useNavigate();

  const logout = async () => {
    // Cleared on BOTH paths. The catch used to redirect to /auth leaving the
    // whole session cache behind, so a failed logout on a shared till handed the
    // next cashier the previous one's open register.
    try {
      await API(controller.Auth + action.Logout).get();
      setAuthUser(null); // clear auth state
      clearSessionScopedCache(); // business context + till + in-flight sale ids
      navigate("/auth"); // redirect
      setBizContext({});
    } catch (error) {
      console.error("Logout failed:", error);
      clearSessionScopedCache();
      navigate("/auth"); // fallback redirect
    }
  };

  return logout;
};

export default useLogout;
